import { Button } from "@/atoms-react/button/Button.react";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react";
import { Themes } from "@/types/theme";
import { useTranslation } from "react-i18next";

type FormFooterProps = {
  currentStep: number;
  onNext?: () => void;
  onPrevious?: () => void;
  nextDisabled?: boolean;
  custom_scenario?: boolean;
};

export const FormFooter = ({
  currentStep,
  onNext,
  onPrevious,
  nextDisabled = false,
  custom_scenario = false
}: FormFooterProps) => {
  const { t } = useTranslation(["atoms"]);
  return (
    <div className={"flex justify-between px-4 pb-4"}>
      <div className={"flex flex-1 justify-start"}>
        {onPrevious && (
          <Button
            theme={Themes.white}
            className={"h-10 w-fit font-medium text-primary"}
            onClick={onPrevious}
          >
            {t("molecules.modal_kyc_identity.previous")}
          </Button>
        )}
      </div>
      <div className={"self-end"}>
        <DotsNavigation total={custom_scenario ? 14 : 3} current={currentStep} />
      </div>
      <div className={"flex flex-1 justify-end"}>
        {onNext && (
          <Button
            dataCy="kyc-form-next-btn"
            theme={Themes.primary}
            className={"h-10 w-fit"}
            disabled={nextDisabled}
            onClick={onNext}
          >
            {t("molecules.modal_kyc_identity.next")}
          </Button>
        )}
      </div>
    </div>
  );
};
